import React from 'react'
import { connect } from 'react-redux'
import { Route, Redirect } from 'react-router-dom'

const PublicPassengerRoute = ({
	isAuthenticated,
	component: Component,
	passenger,
	...rest
}) => {
	return (
		<Route
			{...rest}
			component={(props) =>
				isAuthenticated ? (
					<Redirect to='/passenger/passengers' />
				) : (
					<Component {...props} />
				)
			}
		/>
	)
}

const mapStateToProps = (state) => ({
	passenger: state.app.passenger,
	isAuthenticated: !!state.app.passenger,
})

export default connect(mapStateToProps)(PublicPassengerRoute)
